import { call, put, takeLatest } from 'redux-saga/effects';
import { Apis } from 'src/services/api';
import { getLevelsAsync, getRolesAsync, getTradesAsync } from './actions';

function* getRolesOption(api, action) {
  try {
    const roles = yield call(api);
    yield put(getRolesAsync.success(roles));
  } catch (err) {
    yield put(getRolesAsync.failure(err));
  }
}

function* getLevelsOption(api, action) {
  try {
    const roles = yield call(api);
    yield put(getLevelsAsync.success(roles));
  } catch (err) {
    yield put(getLevelsAsync.failure(err));
  }
}

function* getTradesOption(api, action) {
  try {
    const roles = yield call(api);
    yield put(getTradesAsync.success(roles));
  } catch (err) {
    yield put(getTradesAsync.failure(err));
  }
}

export default function contentSaga(apiInstance: Apis) {
  return [
    takeLatest(getRolesAsync.request, getRolesOption, apiInstance.getRolesOption),
    takeLatest(getTradesAsync.request, getTradesOption, apiInstance.getTradesOption),
    takeLatest(getLevelsAsync.request, getLevelsOption, apiInstance.getLevelsOption),
  ];
}
